import { render, staticRenderFns } from "./TemplateShareDialog.vue?vue&type=template&id=711ff83b&scoped=true"
import script from "./TemplateShareDialog.vue?vue&type=script&lang=js"
export * from "./TemplateShareDialog.vue?vue&type=script&lang=js"
import style0 from "./TemplateShareDialog.vue?vue&type=style&index=0&id=711ff83b&prod&scoped=true&lang=scss"
import style1 from "./TemplateShareDialog.vue?vue&type=style&index=1&id=711ff83b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711ff83b",
  null
  
)

export default component.exports